/**
 * Microsoft Graph feature identity (design 5.2): the single cross-side
 * definition of the feature's name and the canonical entitlement key it
 * carries (Graph integration credentials, token broker/client, admin
 * consent proxy, Graph OpenAPI spec RAG status). Imported by
 * worker/src/features/msgraph/module.ts and
 * frontend/src/features/msgraph/module.ts.
 */

import { defineIdentity } from '../featureModule'

export const identity = defineIdentity({
  name: 'msgraph',
  entitlements: ['msgraph'],
})
